import React, { useEffect } from 'react';

import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';

import { modes } from 'app.config';
import assets from 'assets';

const TabSelector = ({ tab, setTab }) => {
  const dispatch = useDispatch();

  const mode = useSelector(state => state.utils.mode);
  const isOpen = useSelector(state => state.utils.isLeftSideBarOpen);

  const handleTab = val => {
    setTab(val);
    if (val === 0) {
      dispatch.utils.setMode(modes.chat);
    } else {
      dispatch.utils.setMode(modes.document);
    }
  };

  useEffect(() => {
    if (mode === modes.chat) {
      setTab(0);
    } else if (mode === modes.document) {
      setTab(1);
    }
    // eslint-disable-next-line
  }, [mode]);

  return (
    <Tabs left={(100 / 2) * tab} open={isOpen}>
      <Tab onClick={() => handleTab(0)} className={tab === 0 ? 'active' : ''}>
        {isOpen ? (
          'Chats'
        ) : (
          <img
            src={assets.message}
            style={{ filter: `invert(${tab === 0 ? 1 : 0})` }}
            alt=''
          />
        )}
      </Tab>
      <Tab onClick={() => handleTab(1)} className={tab === 1 ? 'active' : ''}>
        {isOpen ? (
          'Documents'
        ) : (
          <img
            src={assets.documentDownload}
            style={{ filter: `invert(${tab === 1 ? 1 : 0})` }}
            alt=''
          />
        )}
      </Tab>
    </Tabs>
  );
};

export default TabSelector;

const Tabs = styled.div`
  width: calc(100% - 10px);
  background-color: ${({ theme }) => theme.colors.lightBlack};
  margin-inline: 10px;
  margin-top: 23px;
  border-radius: 12px;
  padding: 5px;
  display: grid;
  grid-template-columns: ${({ open }) => (!open ? '1fr' : '1fr 1fr')};
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 5px;
    height: ${({ open }) => (!open ? 'calc(50% - 10px)' : 'calc(100% - 10px)')};
    width: ${({ open }) => (open ? 'calc(50% - 10px)' : 'calc(100% - 10px)')};
    background-color: ${({ theme }) => theme.colors.primary};
    left: ${({ left, open }) => (!open ? '5px' : `calc(${left}% + 5px)`)};
    top: ${({ left, open }) => (open ? '5px' : `calc(${left}% + 5px)`)};
    border-radius: 12px;
    z-index: 0;
    transition: all 0.4s ease;
  }
`;

const Tab = styled.div`
  height: 44px;
  display: grid;
  place-items: center;
  font-size: 16px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.primary + 66};
  z-index: 1;
  transition: 0.4s ease;
  cursor: pointer;
  &.active {
    color: ${({ theme }) => theme.colors.lightBlack};
  }
`;
